import type { OverlayMenuBaseProps } from "@/app/components/menu/overlayMenuSystem";
import styles from "./exportPackageMenu.module.scss";

export const EXPORT_PACKAGE_TITLE = "About Export Packages";

// What an export package is, shown in the overlay drawer. The copy, its capitalisation included, is as designed.
// The body is focusable because nothing in it is: without that, keyboard users can't scroll to the end of the
// text when it overflows, since the drawer's focus trap only stops on the dialog and Close.
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- the overlay system reads the title from these props
export default function ExportPackageMenu(_props: OverlayMenuBaseProps) {
  return (
    <div className={styles.ExportPackageMenu} data-export-package-drawer tabIndex={0}>
      <section className={styles.topic}>
        <h3 className={styles.heading}>What does “Export Package” mean?</h3>
        <p className={styles.text}>
          In the Net32 marketplace when a product detail page indicates “Export Package” it means that the original
          equipment manufacturer (OEM) intends for their genuine product to be sold in a market outside of the USA, and
          those products are then re-imported and sold in the United States.
        </p>
      </section>
      <section className={styles.topic}>
        <h3 className={styles.heading}>Differences to note:</h3>
        <ul className={styles.list}>
          <li className={styles.text}>
            Such products may be packaged differently (Export Package) than the products that OEMs intend for sale in
            the United States under the same trade name, including having non-English language markings.
          </li>
          <li className={styles.text}>
            Export package products may also be sold in different quantities than the comparable domestic versions of
            those products.
          </li>
          <li className={styles.text}>
            Export Package products may offer the opportunity to purchase genuine products at substantial discounts as
            compared to the comparable domestic versions of those products.
          </li>
        </ul>
      </section>
    </div>
  );
}
